/**
 * @module Utilities/Location
 * @desc Location helper funtions
 */

import { getLocationPathname } from 'core/utilities/helpers';

/**
 * Check if the pathname already contains /cc/lc
 */
export function isValidLocalePrefix(country: string, locale: string) {
  return !!country && country.length === 2 && !!locale && locale.length === 2;
}

/**
 * Check if the pathname already contains /cc/lc
 */
export function hasPathnamePrefix(pathname: string = getLocationPathname()) {
  const [country, locale] = pathname.split('/').slice(1);

  return isValidLocalePrefix(country, locale);
}
